// Module
var code = `<div class="cp-drawer">
  <div class="cp-header">
    <button type="button" class="cp-home-btn" title="Concept index">📘 Concepts</button>
    <div class="cp-breadcrumb"></div>
    <button type="button" class="cp-close-btn" aria-label="Close concepts panel">✕</button>
  </div>
  <div class="cp-body"></div>
</div>
`;
// Exports
export default code;